import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { withRouter } from 'react-router'
import { IconsCreateTest } from '@edulastic/icons'
import { segmentApi } from '@edulastic/api'
import { WidgetWrap } from './styled'
import { widgetKeys } from './constants'
import {
  isContentConvertEnabledSelector,
  isGcpsDistrictSelector,
  isPremiumUserSelector,
  isVideoQuizAndAIEnabledSelector,
} from '../../../../../src/selectors/user'
import EduAIQuiz from '../../../../../AssessmentCreate/components/CreateAITest'
import BulkConvertDrawer from '../../../../../AssessmentCreate/components/CreateAITest/BulkConvertDrawer'

const Widget = ({
  segmentEvent,
  icon,
  text,
  link,
  aiTest,
  videoQuiz,
  isVideoQuizAndAIEnabled,
  history,
  isGcpsDistrictExcludingDemoUsers,
  widgetKey,
  isContentConvertEnabled,
}) => {
  const Icon = IconsCreateTest[icon]
  const handleClick = () => {
    if (segmentEvent?.name) {
      segmentApi.genericEventTrack(segmentEvent.name, {
        ...(segmentEvent?.data || {}),
      })
    }
    if (
      link &&
      (widgetKey !== widgetKeys.IMPORT_TEST || !isContentConvertEnabled)
    ) {
      history.push(link)
    }
  }

  if (aiTest) {
    return (
      <WidgetWrap data-cy="Use AI" onClick={handleClick} innerStyle>
        <EduAIQuiz displayScreen="dashboard" isILPFlow>
          <Icon />
          <p>{text}</p>
        </EduAIQuiz>
      </WidgetWrap>
    )
  }

  if (isContentConvertEnabled && widgetKey === widgetKeys.IMPORT_TEST) {
    return (
      <WidgetWrap data-cy={text} onClick={handleClick} innerStyle>
        <BulkConvertDrawer source="dashboardShowcaseWidget">
          <>
            <Icon />
            <p>{text}</p>
          </>
        </BulkConvertDrawer>
      </WidgetWrap>
    )
  }

  if (videoQuiz && !isVideoQuizAndAIEnabled) {
    return null
  }

  // dont show google form test for GCPS district excluding demo users
  //  since we are showing content converter
  if (
    isGcpsDistrictExcludingDemoUsers &&
    widgetKey === widgetKeys.GOOGLE_FORM_TEST
  ) {
    return null
  }

  return (
    <WidgetWrap data-cy={text} onClick={handleClick}>
      <Icon />
      <p>{text}</p>
    </WidgetWrap>
  )
}

const enhance = compose(
  withRouter,
  connect(
    (state) => ({
      isVideoQuizAndAIEnabled: isVideoQuizAndAIEnabledSelector(state),
      isGcpsDistrictExcludingDemoUsers: isGcpsDistrictSelector(state, true),
      isPremiumsUser: isPremiumUserSelector(state),
      isContentConvertEnabled: isContentConvertEnabledSelector(state),
    }),
    null
  )
)

export default enhance(Widget)
